import { requestTypeMapping } from '../../../utils/RequestTypeMapping';
import { TranslationType } from '../types';

export const getRequestTypeLabel = (
  requestType: keyof typeof requestTypeMapping,
  t: TranslationType
): string => {
  return requestTypeMapping(t)[requestType];
};
